// Available Setlists : CRUD
// author rodolfo lopez pintor <rlp@nebular.tv>
//////////////////////////////////////////////////////////////

import m from "mithril";
import dayjs from 'dayjs'

import {
	defineWidget, Empty, Icon, CardieWidget, ButtonNew, OverflowUtils, Notification
} from "@nebularstreams/libmui"

import {
	setlistList, setlistGet, setlistCreate
} from "../../Api";

import {STATE_REMIX as STATE} from "../../State";


const

	//////////////////////////////////////////////////////////////
	// AVAILABLE SETLISTS: STRINGS

	STR = {
		SETLIST_CURRENT: "click to set this setlist as the current one",
		SETLIST_CREATE: `Your created reMixes`,
		SETLIST_PROMPT: "Enter a title for your new reMix",
		SETLIST_HINT: "short title",
		SETLIST_CREATE_NEW: "create a new reMix",
		SETLIST_CREATED_NONE: "No reMixes created\nPress the button below to create a new reMix"
	},

	///////////////////////////////////////////////////////////
	// LIST OF AVAILABLE SETLISTS

	setCurrentSetlist = async (orga, setlistId)=>{
		delete STATE.currentSetlist;
		STATE.loadingSetlist = true;
		m.redraw();
		const fullSetlist = await setlistGet(orga, setlistId, true);

		if (fullSetlist.success) {
			STATE.currentSetlist = fullSetlist.data;
		} else {
			Notification.add("Error: " + fullSetlist.error);
		}

		m.redraw();

	},
	// widget: each setlist item
	AvailableSetlistItem = defineWidget(
		(
			{attrs}) => [
			m(
				"li.flexrow",
				{
					title: STR.SETLIST_CURRENT,
					class: [
						STATE.currentSetlist?.setlistId === attrs.item.setlistId ? "current" : "notcurrent"
					].join(" ")
				},
				[
					m(Icon, {
						iconClass: "pad-1 pad-h", icon: "headphones-alt",
					}),
					m("span.name.grows.ellipsis.ohidden", {
						onclick: async () => {
							if (STATE.currentSetlist?.setlistId !== attrs.item.setlistId) {
								await setCurrentSetlist(attrs.orga, attrs.item.setlistId);
							}
						}
					}, attrs.item.title),
					m("span.date.col-4", dayjs(attrs.item.createdAt).fromNow()),
				]
			)
		]),

	// widget: list of setlists
	AvailableSetlists = defineWidget(
		({attrs}) => m(
			CardieWidget,
			{
				class: "setlist",
				element: "div",
				cols: true,
				title: STR.SETLIST_CREATE,
				bodyClass: "scrolly",
				alwaysView: () => m(".flexrow.footer", [
					m(ButtonNew, {
						icon: "plus",
						text: STR.SETLIST_CREATE_NEW,
						onClick: () => {
							OverflowUtils.promptName(
								STR.SETLIST_PROMPT,
								"",
								STR.SETLIST_HINT,
								async (title) => {
									if (!STATE.loadingSetlists) {
										title = (title || "").trim().substring(0, 64);
										if (title) {
											STATE.loadingSetlists = true;
											m.redraw();
											const newSetlist = await setlistCreate(attrs.orga, title);
											if (newSetlist.setlistId) {
												if (STATE.setlistList) STATE.setlistList.push(newSetlist);
												const currentSet = await setCurrentSetlist(attrs.orga, newSetlist.setlistId);

												// const list = await setlistList(attrs.orga);
												if (!currentSet.success) {
													Notification.add(currentSet.error);
												}
											}
											STATE.loadingSetlists = false;
											m.redraw();
										}
									}
								})
						}
					})
				])
			},
			STATE.loadingSetlists
				? m(Empty, {icon: "sync.fa-spin", size: 2, class: "pad-2"})
				: STATE.setlistList?.length
					? m("ul.flexcol.w-100", STATE.setlistList.map(
						(item) => m(AvailableSetlistItem, {item, orga: attrs.orga}))
					)
					: m(Empty, {icon: "headphones-alt", size: 2, message: STR.SETLIST_CREATED_NONE})
		),
		async ({attrs}) => {

			STATE.loadingSetlists = true;
			m.redraw();


			try {
				const list = await setlistList(attrs.orga);
				STATE.setlistList = list.data || [];

			} catch (e) {
				Notification.add(e.message);
			}

			STATE.loadingSetlists = false;
			m.redraw();

		}
	);

export default AvailableSetlists;
